﻿export const leavingWebsitePromptState = function ({
	settings,
}) {
	return {
		settings,
		isOpen: false,
		targetUrl: "",

		setupComponent: function () {
			$(document).on("mousedown", 'a[rel=external]', this, this.displayDialog);
		},
		setModalState: function (value) {
			if (value) {
				document.body.classList.add('ftui__modal--open');
			} else {
				document.body.classList.remove('ftui__modal--open');
			}

			this.isOpen = value;
		},

		displayDialog: function (e) {
			e.preventDefault();

			if (e.button === 0 || e.button === 1) {
				e.data.targetUrl = $(this).attr("href");
				e.data.isOpen = true;
			}
		},

		accept: function () {
			this.isOpen = false;
			window.open(this.targetUrl, '_blank');
			console.log("accept");
		},

		reject: function () {
			this.isOpen = false;
			console.log("reject");
		}
	};
};